import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  theme: {
    primary: '#4287F5',
    secondary: '#083759'
  },
  iconfont: 'mdi'
})
